module.exports = __webpack_public_path__ + "static/media/hero_desktop.751b7fa1.webp";